import {
  ApiError,
  apiResponseErrorHandler,
} from "@shared/apis/sidekick/api-error-handler";
import { getAuthApiClient } from "@shared/apis/sidekick/api-factories";
import { useMutation } from "@tanstack/react-query";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
  onError?: (error: ApiError) => void;
};

type Params = {
  password: string;
  code: string;
  email: string;
};

export const useConfirmResetPassword = (props?: Props) => {
  const { onSuccess, onError } = props || {};
  const api = getAuthApiClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.authControllerConfirmResetPassword({
        confirmResetPasswordRequest: {
          email: params.email,
          token: params.code,
          password: params.password,
        },
      });
      onSuccess?.();
      return response;
    },
    onError: async (e) => {
      const error = await apiResponseErrorHandler(e);
      console.error(`Failed to reset password`, error);
      onError?.(error);
      if (error.status === 429) {
        toast.error(
          "Sorry, we are experiencing a high volume of requests. Please try again later."
        );
        return;
      }
      toast.error(error.errors[0]);
    },
  });

  return mutation;
};
